<div
  class="p-field field"
  [ngClass]="{ 'pt-5': floatingLabel && !styleClass }"
  [class]="styleClass">
  <span [ngClass]="{ 'p-float-label': floatingLabel }">
    <label
      *ngIf="!hideLabel && !floatingLabel"
      class="block mb-2 flex align-items-center gap-2"
      [for]="name">
      @if (icon) {
        <i [class]="icon"></i>
      }
      {{ label }}</label
    >
    <ng-content></ng-content>
    <label
      *ngIf="!hideLabel && floatingLabel"
      class="block mb-2 flex align-items-center gap-2"
      [for]="name">
      @if (icon) {
        <i [class]="icon"></i>
      }
      {{ label }}
      @if (tooltip) {
        <span
          class="text-color-secondary flex gap-1 align-items-baseline pointer-events-auto"
          [pTooltip]="tooltip">
          <i class="fas fa-question-circle"></i>
        </span>
      }
    </label>
  </span>
</div>
<div
  *ngIf="help"
  class="mt-1 text-color-secondary text-xs flex gap-1 align-items-baseline">
  <i class="fas fa-question-circle"></i> {{ help }}
</div>

@if (formField?.touched && formField?.dirty && formField?.errors; as errors) {
  <div class="text-xs">
    <p class="p-error" *ngIf="errors['required']">Dies ist ein Pflichtfeld</p>
    <p class="p-error" *ngIf="errors['lowercaseRequired']">
      nur Kleinbuchstaben erlaubt
    </p>
    <p class="p-error" *ngIf="errors['whitespaceNotAllowed']">
      Keine Leerzeichen erlaubt
    </p>
    <p class="p-error" *ngIf="errors['noSpecialCharsAllowed']">
      Keine Sonderzeichen erlaubt
    </p>
    <p class="p-error" *ngIf="errors['notUnique']">
      Diesen Wert gibt es bereits
    </p>
    <p class="p-error" *ngIf="errors['noAlphanumericAllowed']">
      Nur Zahlenwerte erlaubt
    </p>
    <p class="p-error" *ngIf="errors['yearLength']">
      Das Jahr muss exakt 4-Stellig sein
    </p>
    <p class="p-error" *ngIf="errors['yearArray']">
      Es dürfen nur Jahre eingetragen werden. Jedes Jahr sollte 4-Stellig sein
      und nur Zahlen beinhalten.
    </p>

    <p class="p-error" *ngIf="errors['href']">
      Die Web-Adresse muss mit <i>http://</i> oder <i>https://</i> starten und
      dem oben genannten Format entsprechen.
    </p>
  </div>
}
